<template>
  <v-card>
    <br>
    <br>
    <v-row justify="center">

      <!-- Sketcher -->
      <v-col cols="7">
        <KetcherDraw ref="ketcherDraw"/>
        <p>Draw structure or paste SMILES/MolFile above</p>
      </v-col>

      <!-- Models and submit button -->
      <v-col cols="4">
        <ModelSelector/>
        <v-btn block color="deep-purple-lighten-1" @click="predict()" height="55px"
          class="predict-button">⌬ Predict</v-btn>
        <v-spacer style="height:10px;"/>
        <v-row>
          <v-col>
            <Transition name="warning-fade">
              <v-alert type="warning" color="#ff5555" elevation="10"
                v-show="emptyStructureWarn">Enter a structure</v-alert>
            </Transition>
            <v-spacer style="height:1px;"/>
            <Transition name="warning-fade">
              <v-alert type="warning" color="#ff5555" elevation="10"
                v-show="emptyModelWarn">Select at least one model</v-alert>
            </Transition>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <br>
    <br>
  </v-card>
</template>

<script setup>
import { ref, defineEmits } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'

import KetcherDraw from './KetcherDraw.vue'
import ModelSelector from './ModelSelector.vue'

const store = useStore()
const ketcherDraw = ref(null)

const emptyModelWarn = ref(false)
const emptyStructureWarn = ref(false)

const emit = defineEmits([
  'loading',
  'prediction'
])

async function predict () {
  await ketcherDraw.value.setSmiles()
  const smiles = store.getters.smiles

  // Handle warning together
  if (smiles === '') {
    emptyStructureWarn.value = true
  } else {
    emptyStructureWarn.value = false
  }
  if (store.getters.selectedModels.length === 0) {
    emptyModelWarn.value = true
  } else {
    emptyModelWarn.value = false
  }

  // Return if any warning was triggered
  if (smiles === '' || store.getters.selectedModels.length === 0) {
    return
  }

  emit('loading', true)
  await axios.post(`${store.getters.API}/predict`, {
    models: store.getters.selectedModels,
    smiles: store.getters.smiles
  }).then(res => {
    emit('prediction', res.data)
  })
  emit('loading', false)
}
</script>

<style scoped>
button.v-btn.predict-button {
  margin-top: 10px;
}

p {
  font-size: 20px;
  color: #f8f8f2;
  text-align: left;
}

p.prediction-text {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
</style>
